/**
 * Validates that an email address is valid
*/
export function emailValidator(email: string): boolean {
  return !!EMAIL_REGEX.test(email.trim());
};

/**
 * Sanitizes email input by lowercasing and removing whitespace and commas.
 */
export function sanitizeEmail(value: string): string {
  return value.toLowerCase().replace(/[,\s]/g, '');
}

const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
